import { Button, Collapse, notification } from "antd";
import { Col, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { CallServices, CoreServices } from "../../../../base/service/apiServices";
import { ChatActions } from "../../../../store/slices/chat_slice/chat_slice";
import { ChatState } from "../../../../base/models/model";
import moment from "moment";
import Plansupgrade from '../../../../styles/images/Premium.svg'
import styles from "./chatLeftSideBar.module.scss";
import { ROLES } from "../../../../base/constant";
import { useDispatcher } from "../../../../custom_hooks/use_app_dispatch";
import { useSelector } from "react-redux";
import { GetItemFromStorage } from "../../../../custom_hooks/useStorage";
import { LocalStorage } from "../../../../custom_hooks/localStorageKeys";
import { groupbydayForAssign, hassAccess, navigateToTicketing } from "../../../../base/utils";
import { getNecessaryDetailswithsession } from "../../../../store/api/helperspi/contactListapiService";
import { allActivityActions } from "../../../../store/slices/all_activity_slice/all_activity_slice";
import { useNavigate } from "react-router";
import Loaders from "../../../loader/loader";
import store from "../../../../store/redux-store/root_store";
import { v4 as uuidv4 } from "uuid";

function BrowserSoftware() {
  const dispatch = useDispatcher();
  const navigate = useNavigate();
  const chatReducer: any = useSelector((state: any) => state.chatReducer);
  const [interactionData, setInteractionData] = useState<any>([]);
  const { Panel } = Collapse;
  const [loading, setLoading] = useState<any>(false);
  let { currentSession } = chatReducer;
  const [sessionId, setSessionId] = useState<any>("");
  const [currentIndex, setCurrentIndex] = useState<any>(-1);

  const popUpDetails: any = store.getState().callPopUpDetails;
  let { incomingCallDetail, callDetails, isTransfer, queueName } = popUpDetails;

  useEffect(() => {
    /*
    let _sessionId: any = "";
    if (currentSession.sessionId !== _sessionId) {
      init();
      _sessionId = currentSession.sessionId;
    }
    */
    if (currentSession.sessionId !== sessionId) {
      setSessionId(currentSession.sessionId);
      init();
    }
  }, [currentSession.sessionId]);

  const init = async () => {
    try {
      if (window.location.pathname !== "/login" && window.location.pathname !== "/") {
        let phone_num = 0, email_id = ''

        if (currentSession?.calledPersonDetails) {
          // if (currentSession?.channelType !== 'Chat') {
          //   if ((currentSession.calledPersonDetails.phoneNumber !== null && currentSession.calledPersonDetails.phoneNumber !== '') || (currentSession?.CallHistoryId && currentSession?.CallHistoryId !== "")) {
          //     phone_num = currentSession?.calledPersonDetails?.phoneNumber?.replace(/[\[\]"]/g, "")
          //     email_id = currentSession?.calledPersonDetails?.email?.toString()?.replace(/[\[\]"]/g, "")
          //   }
          // } else {
          //   if (currentSession?.email !== '' && currentSession?.email !== null) {
          //     email_id = currentSession?.email?.toString()?.replace(/[\[\]"]/g, "")
          //   }
          //   if (currentSession?.phoneNumber !== '' && currentSession?.phoneNumber !== null) {
          //     phone_num = currentSession?.phoneNumber?.toString()?.replace(/[\[\]"]/g, "")
          //   }
          // }
          phone_num = currentSession?.calledPersonDetails?.phoneNumber?.replace(/[\[\]"]/g, "") || currentSession?.phoneNumber?.toString()?.replace(/[\[\]"]/g, "")
          email_id = currentSession?.calledPersonDetails?.email?.toString()?.replace(/[\[\]"]/g, "") || currentSession?.email?.toString()?.replace(/[\[\]"]/g, "")
        }
        let body: any = {
          customerId: currentSession?.calledPersonDetails?.coid,
          customerFacebookId: currentSession?.calledPersonDetails?.facebook ? parseInt(currentSession?.calledPersonDetails?.facebook) : null,
          customerInstagramId: currentSession?.calledPersonDetails?.instagram ? parseInt(currentSession?.calledPersonDetails?.instagram) : null,
          emailId: email_id,
          phoneNumber: phone_num,
          startTmpstmp: null, // start of today in timestamp (ms)
          endTmpstmp: null,
        };
        // setLoading(true);
        getActivityList(body);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getActivityList = (body: any) => {
    try {
      CoreServices.post(body, `/get_interaction_details`)
        .then((response: any) => {
          if (response && response.data.statusCode === 200) {
            let response_data: any = [...response.data.getInteractionResponse]
            if (response_data && response_data.length > 0) {
              setLoading(false);
              setInteractionData(response_data)
            }
          }
        })
        .catch((err) => {
          console.log(err);
          notification.info({
            message: "network error",
            placement: "topRight",
            className: "toastNotification error",
            icon: <span className="icon__Error24" />,
            closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
              <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
            </svg>,
            duration: 3,
            top: 70,
          });
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const goToWorkspace = (e: any, index: any, value: any) => {
    console.log("goToWorkspace11111111", value)
    let chatSessionData: any = {}
    chatSessionData.calledPersonDetails = { ...currentSession?.calledPersonDetails }
    chatSessionData.scrollId = value.sessionId
    let phone_num = '', email_id = ''
    if (currentSession?.calledPersonDetails) {
      // if (currentSession?.channelType !== 'Chat') {
      //   if ((currentSession.calledPersonDetails.phoneNumber !== null && currentSession.calledPersonDetails.phoneNumber !== '') || (currentSession?.CallHistoryId && currentSession?.CallHistoryId !== "")) {
      //     phone_num = currentSession?.calledPersonDetails?.phoneNumber?.replace(/[\[\]"]/g, "")
      //     email_id = currentSession?.calledPersonDetails?.email?.toString()?.replace(/[\[\]"]/g, "")
      //   }
      // } else {
      //   if (currentSession?.email !== '' && currentSession?.email !== null) {
      //     email_id = currentSession?.email?.toString()?.replace(/[\[\]"]/g, "")
      //   }
      //   if (currentSession?.phoneNumber !== '' && currentSession?.phoneNumber !== null) {
      //     phone_num = currentSession?.phoneNumber?.toString()?.replace(/[\[\]"]/g, "")
      //   }
      // } 
      phone_num = currentSession?.calledPersonDetails?.phoneNumber?.replace(/[\[\]"]/g, "") || currentSession?.phoneNumber?.toString()?.replace(/[\[\]"]/g, "")
      email_id = currentSession?.calledPersonDetails?.email?.toString()?.replace(/[\[\]"]/g, "") || currentSession?.email?.toString()?.replace(/[\[\]"]/g, "")
    }
    const channelHistoryKeys = [
      "ChatHistoryId",
      "EmailHistoryId",
      "WhatsappHistoryId",
      "SMSHistoryId",
      "FacebookHistoryId",
      "InstagramHistoryId",
      "CallHistoryId"
    ];

    const found: any = channelHistoryKeys.find(key => value?.[key]);
    console.log("insertoverallnotesinsertoverallnotes", value, found)
    let body: any = {
      customerId: value?.CustomerId,
      customerFacebookId: parseInt(value?.facebook) ?? null,
      customerInstagramId: parseInt(value?.instagram) ?? null,
      emailId: email_id,
      phoneNumber: phone_num,
      interactionId: value[found],
      TicketId: value?.ticketId
    };
    getAllInteraction(body, chatSessionData);
    // setLoading(true)

  };

  const getAllInteraction = (body: any, chatSessionData: any) => {
    try {
      CoreServices.post(body, `/get_interaction_details_view`)
        .then((response: any) => {
          if (response && response.data.statusCode === 200) {
            let response_data: any = [...response.data.getInteractionViewResponse]
            chatSessionData.sessionId = chatSessionData.sessionId || uuidv4()
            chatSessionData.isInteractionView = true
            chatSessionData.interactionData = response_data
            dispatch(ChatActions.setinteractionData(response_data));
            dispatch(ChatActions.chatSessionList(chatSessionData));
            dispatch(ChatActions.currentChatSession(chatSessionData));
          }
        })
        .catch((err) => {
          console.log(err);
          notification.info({
            message: "network error",
            placement: "topRight",
            className: "toastNotification error",
            icon: <span className="icon__Error24" />,
            closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
              <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
            </svg>,
            duration: 3,
            top: 70,
          });
        })
        .finally(() => setLoading(false))
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (Object.keys(incomingCallDetail).length > 0) {
      setCurrentIndex(0);
    }
    else {
      setCurrentIndex(-1);
    }
  }, []);

  const getIndex = () => {
    if (Object.keys(incomingCallDetail).length > 0) {
      return 0;
    }
    return -1;
  };

   const open =()=>{
        navigateToTicketing()
    }

  return (
    <>
      {loading && <Loaders />}
      <div className={`${styles.individualRow} ${!hassAccess('workspace/interaction') && styles.individualRowud}`}>
        {/* add condition individualRowud this class */}
        {
          !hassAccess('workspace/interaction')
            ?
            <div className={styles.broweru}>
              <div className={styles.indivualtst}>
                <p>Upgrade plan to view
                  Interactions</p>
                <div className={styles.plgrde}>
                  <img src={Plansupgrade} alt="" />
                  {/* <button onClick={open}>Upgrade</button> */}
                </div>
              </div>
            </div>
            :
            <div className={`BrowserInfo scroller ${styles.BrowserInfo}`}>

              {interactionData.length > 0 && interactionData.map((data: any, index: any) => {
                console.log("interactionDatainteractionData", data)
                if (index >= currentIndex && data?.sessionId !== currentSession?.sessionId) { //data?.sessionId !== currentSession?.sessionId
                  let customerName: any = currentSession?.calledPersonDetails?.firstName ?
                    (currentSession?.calledPersonDetails?.lastName ? (currentSession?.calledPersonDetails?.firstName + " " + currentSession?.calledPersonDetails?.lastName)
                      : currentSession?.calledPersonDetails?.firstName)
                    : 'New customer'
                  return (
                    <>
                      <div className={`${styles.timeline} ${styles.timelinetab} timelinetab`}>
                        <span
                          className={`${data.channelType === "Call"
                            ? "icon__Chatcall24"
                            : data.channelType === "Sms"
                              ? "icon__ChatSms24"
                              : data.channelType === "outCall"
                                ? "icon__InteractionOutCall24"
                                : data.channelType === "Facebook"
                                  ? "icon__InteractionFacebook24"
                                  : data.channelType === "twitter"
                                    ? "icon__InteractionTwitter24"
                                    : data.channelType === "Chat"
                                      ? "icon__InteractionMessage24"
                                      : data.channelType === "Instagram"
                                        ? "icon__InteractionInsta24"
                                        : data.channelType === "linkedIn"
                                          ? "icon__InteractionLinkedin24"
                                          : data.channelType === "Email"
                                            ? "icon__ChatEmail24"
                                            : data.channelType === "Whatsapp"
                                              ? "icon__Chatwhatsapp24"
                                              : "icon__Chatcall24"
                            } `}
                        ></span>

                        <div className={styles.timelineinfo}>
                          <h5>{customerName}</h5>
                          <p className={styles.overDt}>
                            <span>{moment(data?.updatedAt).format("LLL")}</span>
                            <span
                              className={
                                data?.dispositionName === "Resolved"
                                  ? styles.solved
                                  : data?.dispositionName === "Closed"
                                    ? styles.newmsg
                                    : data?.dispositionName === "Follow-up"
                                      ? styles.follow
                                      : data?.dispositionName === "Do not contact"
                                        ? styles.dnd
                                        : data?.dispositionName === "Unresolved"
                                          ? styles.open
                                          : styles.normal
                              }
                            >
                              {data?.dispositionName}
                            </span>
                          </p>
                          <div className={styles.timelineinfo}>
                            {data?.dispositionSummary !== "" && <p className={styles.interactionDt}>{data?.dispositionSummary}</p>}
                            { }<Button onClick={(e: any) => goToWorkspace(e, index, data)}>View Interaction</Button>
                          </div>
                        </div>

                        {/* <Collapse defaultActiveKey={["0"]}>
                      <Panel
                        header={
                          <div className={styles.timelineinfo}>
                            <h5>{customerName}</h5>
                            <p>
                              <span>{moment(data?.updatedAt).format("LLL")}</span>
                              <span
                                className={
                                  data?.dispositionName === "Resolved"
                                    ? styles.solved
                                    : data?.dispositionName === "Closed"
                                      ? styles.newmsg
                                      : data?.dispositionName === "Follow-up"
                                        ? styles.follow
                                        : data?.dispositionName === "Do not contact"
                                          ? styles.dnd
                                          : data?.dispositionName === "Unresolved"
                                            ? styles.open
                                            : styles.normal
                                }
                              >
                                {data?.dispositionName}
                              </span>
                            </p>
                          </div>
                        }
                        key={index}
                      >
                        <div className={styles.timelineinfo}>
                          {data?.dispositionSummary !== "" && <p>{data?.dispositionSummary}</p>}
                          <br />
                          { }<Button onClick={(e: any) => goToWorkspace(e, index, data)}>View Interaction</Button>
                        </div>
                      </Panel>
                    </Collapse> */}
                      </div>
                    </>
                  )
                }
              })}
            </div>
        }
      </div>
    </>
  );
}
export default BrowserSoftware;
